// src/data/courses.js
import astrologyImg from "../assets/courses/astrology.png";
import lalKitabImg from "../assets/courses/lal-kitab.png";
import numerologyImg from "../assets/courses/numerology.png";
import pranicHealingImg from "../assets/courses/pranic-healing.png";
import vastuImg from "../assets/courses/vastu-shastra.png";
import reikiImg from "../assets/courses/reiki-healing.png";
import eftImg from "../assets/courses/eft-tapping.png";
import tarotImg from "../assets/courses/tarot.png";
import kpAstrologyImg from "../assets/courses/kp-astrology.png";
import akashicImg from "../assets/courses/akashic-records.png";
import nakshatraImg from "../assets/courses/nakshatra.png";
import palmistryImg from "../assets/courses/palmistry.png";
import graphologyImg from "../assets/courses/graphology.png";
import loaImg from "../assets/courses/law-of-attraction.png";
import crystalImg from "../assets/courses/crystal-healing.png";
import acupressureImg from "../assets/courses/acupressure.png";
import faceReadingImg from "../assets/courses/face-reading.png";
import loShuImg from "../assets/courses/lo-shu.png";

const courses = [
  {
    id: "astrology",
    title: "Vedic Astrology Mastery",
    description: "Discover how planets and stars influence your life and master Vedic Astrology.",
    image: astrologyImg,
    duration: "2.5 Months"
  },
  {
    id: "lal-kitab",
    title: "Lal Kitab Remedies & Predictions",
    description: "Learn planetary remedies, predictions, and ancient secrets of Lal Kitab.",
    image: lalKitabImg,
    duration: "2 Months"
  },
  {
    id: "numerology",
    title: "Numerology Insights",
    description: "Uncover the hidden power of numbers and how they shape your destiny.",
    image: numerologyImg,
    duration: "1.5 Months"
  },
  {
    id: "pranic-healing",
    title: "Pranic Healing Course",
    description: "Enhance your inner energy and wellbeing with practical Pranic Healing techniques.",
    image: pranicHealingImg,
    duration: "2 Months"
  },
  {
    id: "vastu-shastra",
    title: "Vastu Shastra Guidance",
    description: "Learn to balance energies in your home and workspace with Vastu principles.",
    image: vastuImg,
    duration: "1.5 Months"
  },
  {
    id: "reiki-healing",
    title: "Advanced Reiki Healing",
    description: "Heal your mind, body, and spirit with our expert Reiki healing course.",
    image: reikiImg,
    duration: "2 Months"
  },
  {
    id: "eft-tapping",
    title: "EFT Tapping for Emotional Wellness",
    description: "Release emotional blockages naturally and improve your mental health.",
    image: eftImg,
    duration: "1 Month"
  },
  {
    id: "tarot-cards-reading",
    title: "Tarot Card Reading",
    description: "Learn to read Tarot cards and gain insights into your future and guidance.",
    image: tarotImg,
    duration: "1.5 Months"
  },
  {
    id: "kp-astrology",
    title: "KP Astrology Expertise",
    description: "Master KP Astrology to make precise predictions for yourself and others.",
    image: kpAstrologyImg,
    duration: "2 Months"
  },
  {
    id: "akashic-records",
    title: "Akashic Records Exploration",
    description: "Discover the secrets hidden in your soul and access the Akashic Records.",
    image: akashicImg,
    duration: "1.5 Months"
  },
  {
    id: "nakshatra-jyotish",
    title: "Nakshatra Jyotish Insights",
    description: "Decode the 27 Nakshatras and understand your cosmic path.",
    image: nakshatraImg,
    duration: "2 Months"
  },
  {
    id: "palmistry",
    title: "Palmistry Secrets",
    description: "Learn professional palm reading techniques and reveal life patterns.",
    image: palmistryImg,
    duration: "1.5 Months"
  },
  {
    id: "graphology",
    title: "Graphology & Handwriting Analysis",
    description: "Understand personality traits and behavior through handwriting analysis.",
    image: graphologyImg,
    duration: "1 Month"
  },
  {
    id: "law-of-attraction",
    title: "Law of Attraction Mastery",
    description: "Manifest your dreams and create the life you desire with this course.",
    image: loaImg,
    duration: "1.5 Months"
  },
  {
    id: "crystal-healing",
    title: "Crystal Healing Techniques",
    description: "Balance energies and promote harmony in your life using crystals.",
    image: crystalImg,
    duration: "1 Month"
  },
  {
    id: "acupressure",
    title: "Acupressure for Mind & Body",
    description: "Learn professional acupressure techniques to relieve stress and improve health.",
    image: acupressureImg,
    duration: "1.5 Months"
  },
  {
    id: "face-reading",
    title: "Face Reading & Analysis",
    description: "Decode personality and future insights through the art of face reading.",
    image: faceReadingImg,
    duration: "1 Month"
  },
  {
    id: "lo-shu-numerology",
    title: "Lo Shu Numerology",
    description: "Explore how numbers influence your life with our Lo Shu numerology course.",
    image: loShuImg,
    duration: "1 Month"
  },
];

export default courses;
